
import { computed, defineComponent, onUnmounted, ref } from 'vue';
import TableSetting from './components/TableSetting.vue';
import { createNamespacedHelpers } from '@/common/vuex-composition-hooks';
import { ISettingState, ISettingActions, IUsers } from './types';
import SettingsModal from './SettingsModal.vue';
import { mapActions, mapGetters } from 'vuex';

interface IFilter {
  value: number;
  text: string;
  active: boolean;
}

const { useState, useActions } = createNamespacedHelpers<
  ISettingState,
  null,
  ISettingActions,
  IUsers
>('setting');
export default defineComponent({
  name: 'SettingPage',
  components: {
    TableSetting,
    SettingsModal,
  },

  computed: {
    ...mapGetters('auth', ['getExpeditionUsersList']),
    tabs() {
      return [
        {
          name: 'Parâmetros',
          code: 'Q',
          active: false,
          settingType: 'parameters',
          fields: [
            {
              name: 'PAR_DESCRICAO',
              header: 'Parâmetro',
            },
            {
              name: 'PAR_CONTEUDO',
              header: 'Valor',
            },
          ],
        },
        {
          name: 'Tabela',
          code: 'T',
          active: false,
          settingType: 'parameters',
          fields: [
            {
              name: 'FIELD',
              header: 'Coluna',
            },
            {
              name: 'OPERATOR',
              header: 'Relação',
            },
            {
              name: 'VALUE',
              header: 'Valor',
            },
            {
              name: 'BGCOLOR',
              header: 'Cor de Fundo',
            },
            {
              name: 'TEXTCOLOR',
              header: 'Cor do Texto',
            },
          ],
        },
      ];
    },
  },

  setup() {
    const { filterUsers } = useActions(['filterUsers']);
    const { getUsers } = useState(['getUsers']);
    const { selectedUser } = useState(['selectedUser']);

    const setting = ref(getUsers);
    const filterText = ref('');

    const settingFiltered = computed(() => {
      if (filterText.value) return filterUserGroup(filterText.value);

      return setting.value;
    });

    const isSave = ref(false);

    onUnmounted(() => {
      isSave.value = false;
    });

    const timeAlert = () => {
      isSave.value = true;

      setTimeout(() => {
        isSave.value = false;
      }, 3000);
    };

    const stringNormalizeAndUpper = (userGroup) => {
      return userGroup
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toUpperCase();
    };

    const filterUserGroup = (filter) => {
      const settingFiltered = { ...setting.value };
      const normalizedFilter = stringNormalizeAndUpper(filter);
      Object.keys(setting.value).map((key) => {
        if (!stringNormalizeAndUpper(key).includes(normalizedFilter)) {
          delete settingFiltered[key];
        }
      });

      return settingFiltered;
    };
    return {
      filterUserGroup,
      filterUsers,
      filterText,
      settingFiltered,
      timeAlert,
      isSave,
      setting,
      selectedUser,
    };
  },

  methods: {
    ...mapActions('auth', ['getExpeditionUsers']),
    ...mapActions('setting', ['toggleModalStatus']),
    ...mapActions('setting', ['setSelectedUser']),
    ...mapActions('setting', ['changeAddressStatus']),
    search() {
      this.filterUsers({ name: this.searchvalue, param: this.activeParam() });
    },
    handlevalue(input) {
      this.searchvalue = input.target.value;
    },

    toggleModal(user: IUsers) {
      this.toggleModalStatus(true);
      this.setSelectedUser(user);
    },

    closeModal() {
      this.toggleModalStatus(false);
      this.setSelectedUser('');
    },

    activeFilter(filters: IFilter[]) {
      return filters
        .filter((filter: IFilter) => filter.active == true)
        .map(({ text }) => text)[0];
    },

    activeParam() {
      return this.filters
        .filter((filter: IFilter) => filter.active == true)
        .map(({ value }) => value)[0];
    },

    toggleFilter(selectedfilter: IFilter) {
      this.filters.forEach((filter: IFilter) => {
        if (filter.value == selectedfilter.value) {
          filter.active = true;
        } else {
          filter.active = false;
        }
      });
    },

    handleToggleAddressStatus(row) {
      row.PAR_ATIVO = row.PAR_ATIVO === 'S' ? 'N' : 'S';
      this.changeAddressStatus(row);
    },
  },
  mounted() {
    this.getExpeditionUsers();
  },

  data() {
    return {
      searchvalue: '',
      showModal: false,
      filters: [
        {
          value: 1,
          text: 'Login Exato',
          active: true,
        },
        {
          value: 2,
          text: 'Login Aproximado',
          active: false,
        },
        {
          value: 3,
          text: 'Nome Exato',
          active: false,
        },
        {
          value: 4,
          text: 'Nome Aproximado',
          active: false,
        },
      ],
    };
  },
});
